/**
 * 购物车接口API  created by song 2017/12/21
 */
import Vue from "vue";
import { Get, Post, _axios } from "@common";
import Qs from "qs";
// import {CONFIG.SITE_CONFIG} from "projectConfig";

export default {
  upSelect(params) {
    return Get(CONFIG.BASE_URL + "/cart/upSelect.do", {
      params: params
    });
  },
  submitRHEBOrder(params) {
    return Post(
      CONFIG.BASE_URL + "/order/submitRHEBOrder.do",
      Qs.stringify(params),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
    );
  },
  payRHEBOrder(params) {
    return Post(
      CONFIG.BASE_URL + "/order/payRHEBOrder.do",
      Qs.stringify(params),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
    );
  },
  queryShoppingCart(param, cb) {
    // let loading = Vue.prototype.$loading();
    var stamp = new Date().getTime();
    _axios
      .get(
        CONFIG.BASE_URL +
          "cart/getCartAndActivity.do?loginName=" +
          param.loginName +
          "&siteId=" +
          CONFIG.SITE_CONFIG.siteId +
          "&timeStamp=" +
          stamp
      )
      .then(function(response) {
        if (cb && cb instanceof Function) {
          if (response.data.data && response.data.data.content) {
            var len = response.data.data.content.length;
            var tempLen = 0;
            var listWrapper = response.data.data.content;
            for (var i = 0; i < len; i++) {
              // for (var j = 0; j < listWrapper[i].list.length; j++) {
              //   tempLen += listWrapper[i].list[j].nums;
              // }
              tempLen += listWrapper[i].list.length;
            }
            cb({
              productList: response.data.data.content,
              totalCount: tempLen
            });
          }
        }
        // loading.close();
      })
      .catch(function() {
        // loading.close();
      });
  },
  deleteCartProduct(ids, cb) {
    _axios
      .post(CONFIG.BASE_URL + "cart/deleteCart.do?ids=" + ids)
      .then(function(res) {
        // console.log(res);
        if (cb && cb instanceof Function) {
          if (res.data && res.data.result == 1) {
            cb({ deleteStatus: true });
          } else {
            cb({ deleteStatus: false });
          }
        }
      });
  },
  changeProductCount(params, cb) {
    _axios
      .get(CONFIG.BASE_URL + "cart/updateCart.do", { params: params })
      .then(function(response) {
        if (cb && cb instanceof Function) {
          if (
            response.data.result === "0" &&
            response.data.error &&
            response.data.error.errorCode === "403"
          ) {
            // 判断登录失效
            Vue.prototype.$alert("登录失效，请您重新登录。", "系统提示", {
              confirmButtonText: "确定"
            });
            return false;
          }
          cb({
            changeStatus: true
          });
        }
      })
      .catch(function(error) {});
  },
  queryOrderAddress(params, cb) {
    _axios
      .get(CONFIG.BASE_URL + "user/addresses.do?loginName=" + params.loginName)
      .then(function(response) {
        if (cb && cb instanceof Function) {
          var res =
            response.data && response.data.result ? response.data.result : "0";
          if (res === "1") {
            cb({
              addressList: response.data.data
            });
          } else {
            cb({
              addressList: []
            });
          }
        }
      });
  },
  addOrderAddress(params, cba) {
    _axios
      .post(CONFIG.BASE_URL + "user/addAddress.do?", params)
      .then(function(response) {
        if (cba && cba instanceof Function) {
          cba({
            addStatus: true
          });
        }
      })
      .catch(function(error) {});
  },
  queryDefaultAddress(name, cb) {
    _axios
      .get(CONFIG.BASE_URL + "user/getDefalutAddress.do?loginName=" + name)
      .then(function(response) {
        if (cb && cb instanceof Function) {
          cb({
            defaultAddress: response.data.data
          });
        }
      });
  },
  checkCoupons(password, cb) {
    _axios
      .get(CONFIG.BASE_URL + "user/checkCoupons.do?couponPassword=" + password)
      .then(function(response) {
        if (cb && cb instanceof Function) {
          var res = response.data.result; // 返回结果 1：成功 0：失败
          if (res === "1") {
            cb({
              checkStatus: response.data.data
            });
          } else {
            var errorMsg = {
              status: false,
              price: 0,
              msg: response.data.error.errorMsg
            };
            cb({
              checkStatus: errorMsg
            });
          }
        }
      })
      .catch(function(error) {});
  },
  getPayment(data, cb) {
    _axios
      .get(
        CONFIG.BASE_URL +
          "cart/getPayMethod.do" +
          "?siteId=" +
          CONFIG.SITE_CONFIG.siteId
      )
      .then(function(response) {
        if (cb && cb instanceof Function) {
          cb({
            paymentList: response.data.data
          });
        }
      });
  },
  getDeliveryWay(datas, cb) {
    _axios
      .get(CONFIG.BASE_URL + "cart/findDeliverysByStatus.do")
      .then(function(response) {
        if (cb && cb instanceof Function) {
          cb({
            deliveryList: response.data.data
          });
        }
      })
      .catch(function(error) {});
  },
  commitOrder(params, cb) {
    let loading = Vue.prototype.$loading({
      text: "数据加载中..."
    });
    _axios
      .post(CONFIG.BASE_URL + "order/submitSplitOrder.do", params)
      .then(function(response) {
        if (cb && cb instanceof Function) {
          if (response.data.result == "1" && response.data.data) {
            cb({
              commitInfo: response.data.data
            });
          } else {
            let tipInfo =
              response.data.error && response.data.error.errorMsg
                ? response.data.error.errorMsg
                : "操作有误";
            Vue.prototype.$alert(tipInfo, "系统提示", {
              confirmButtonText: "确定"
            });
          }
          loading.close();
        }
      });
  },
  addFavorite(params, cb) {
    _axios
      .post(
        CONFIG.BASE_URL +
          "collection/addCollect.do?loginName=" +
          params.loginName +
          "&pubId=" +
          params.pubId +
          "&operateType=" +
          params.operateType +
          "&productId=" +
          params.productId +
          "&siteId=" +
          CONFIG.SITE_CONFIG.siteId
      )
      .then(function(response) {
        if (cb && cb instanceof Function) {
          if (
            response.data.result === "0" &&
            response.data.error &&
            response.data.error.errorCode === "403"
          ) {
            // 判断登录失效
            Vue.prototype.$alert("登录失效，请您重新登录。", "系统提示", {
              confirmButtonText: "确定"
            });
            return false;
          }
          cb({
            favoriteStatus: response.data.data.code
          });
        }
      })
      .catch(function(error) {});
  },
  queryVirtualCoin(loginName, cb) {
    _axios
      .get(
        CONFIG.BASE_URL +
          "rechargeVirtualCoin/getCoinByName.do?loginName=" +
          loginName
      )
      .then(function(response) {
        if (cb && cb instanceof Function) {
          cb({
            virtualCoin: response.data.data
          });
        }
      });
  },
  getRmbCoin(virtualCoin, cb) {
    _axios
      .get(
        CONFIG.BASE_URL +
          "rechargeVirtualCoin/getRbm.do?virtualCoin=" +
          virtualCoin
      )
      .then(function(response) {
        if (cb && cb instanceof Function) {
          cb({
            rmbCoin: response.data.data
          });
        }
      })
      .catch(function(error) {});
  },
  changeActivity(params, cb) {
    _axios
      .get(
        CONFIG.BASE_URL +
          "cart/getCartAndActivityForChange.do?loginName=" +
          params.loginName +
          "&siteId=" +
          CONFIG.SITE_CONFIG.siteId +
          "&productId=" +
          params.productId +
          "&activityId=" +
          params.activityId
      )
      .then(function(response) {
        if (cb && cb instanceof Function) {
          if (
            response.data.result === "0" &&
            response.data.error &&
            response.data.error.errorCode === "403"
          ) {
            // 判断登录失效
            Vue.prototype.$alert("登录失效，请您重新登录。", "系统提示", {
              confirmButtonText: "确定"
            });
            return false;
          }
          cb({
            changeActivity: response.data.result === "1" ? true : false
          });
        }
      });
  },
  /**
   * 购物车 根据用户名获取优惠券
   */
  queryCoupons(params, cb) {
    _axios
      .get(
        CONFIG.BASE_URL +
          "user/getCounponsByName.do?loginName=" +
          params.loginName +
          "&type=" +
          params.type
      )
      .then(function(response) {
        if (cb && cb instanceof Function) {
          cb({
            couponsList:
              response.data.result === "1" ? response.data.data : false
          });
        }
      });
  }
};



// WEBPACK FOOTER //
// ./src/components/work/shoppingCart/01_shoppingCart/api/shoppingCartApi.js